import { createFileRoute } from '@tanstack/react-router'

import { ContractsPageSkeleton } from '#/modules/contract/front-office/contracts-page/contracts-page-skeleton.tsx'
import { ContractsPage } from '#/modules/contract/front-office/contracts-page/contracts-page.tsx'
import { frontOfficeQueryOptions } from '#/shared/front-office-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/contracts/')({
  beforeLoad: (options) => requirePermissions(options, ['contract.read']),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(
        context.trpc.contracts.listMyContracts.queryOptions(undefined, frontOfficeQueryOptions),
      ),
      context.queryClient.ensureQueryData(
        context.trpc.subscriptions.listMyUnsignedSubscriptions.queryOptions(
          { isArchived: false },
          frontOfficeQueryOptions,
        ),
      ),
    ]),
  pendingComponent: ContractsPageSkeleton,
  pendingMs: 150,
  component: ContractsPage,
})
